import moment from "moment";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString } from "utils/Constant";


export const checkRole = (user_role = "", role = "") => {
   const userRole = user_role?.toLowerCase();
   return userRole === role
}

export const RoundTwoDecimals = (number = 0) => {
   return Math.round((number + Number.EPSILON) * 100) / 100;
};

export const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
export const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");

export const money = event => {
   if (!CheckUndefined(event)) {
      return ''
   }

   return (addCommas(removeNonNumeric(event)))
}

export const GetStatus = e => {
   let status = EmptyString
   
   if (e.toString() === "1"){
      status = "Active"
   }else if(e.toString() === "2"){
      status = "Deleted"
   }else if(e.toString() === "3"){
      status = "Pending"
   }else if(e.toString() === "4"){
      status = EmptyString
   }else{
      status = EmptyString
   }
   
   return status
}

export const GetPaymentType = e => {
   let paymentType = EmptyString

   if (e.toString() === "1"){
      paymentType = "Termin 1"
   }else if(e.toString() === "2"){
      paymentType = "Termin 2"
   }else if(e.toString() === "3"){
      paymentType = "Termin 3"
   }else if(e.toString() === "4"){
      paymentType = "Termin 4"
   }else if(e.toString() === "5"){
      paymentType = "Termin 5"
   }else{
      paymentType = EmptyString
   }

   return paymentType
}

export const GetDivision = e => {
   let division = EmptyString

   if (e.toString() === "1"){
      division = "Director"
   }else if(e.toString() === "2"){
      division = "HR"
   }else if(e.toString() === "3"){
      division = "Manager"
   }else if(e.toString() === "4"){
      division = "Supervisor"
   }else if(e.toString() === "5"){
      division = "Attendance"
   }else if(e.toString() === "6"){
      division = "Juru Parkir"
   }else{
      division = EmptyString
   }

   return division
}

export const GetTransactionType = e => {
   let type = EmptyString

   if (e.toString() === "1"){
      type = "Car Parking"
   }else if(e.toString() === "2"){
      type = "Motorcycle Parking"
   }else if(e.toString() === "3"){
      type = "Valet"
   }else{
      type = EmptyString
   }

   return type
}

export const GetTransactionStatus = e => {
   let type = EmptyString

   if (e.toString() === "1"){
      type = "Open"
   }else if(e.toString() === "2"){
      type = "Close"
   }else{
      type = EmptyString
   }

   return type
}
export const GetPaymentStatus = e => {
   let type = EmptyString

   if (e.toString() === "1"){
      type = "Paid"
   }else if(e.toString() === "2"){
      type = "Unpaid"
   }else{
      type = EmptyString
   }

   return type
}
export const GetPaymentOptions = e => {
   let type = EmptyString

   if (e.toString() === "1"){
      type = "Cash"
   }else if(e.toString() === "2"){
      type = "Bank Transfer"
   }else if(e.toString() === "3"){
      type = "QRIS"
   }else if(e.toString() === "4"){
      type = "Debit/Credit"
   }else if(e.toString() === "5"){
      type = "Membership"
   }else{
      type = EmptyString
   }

   return type
}
export const GetReturnStatus = (e) => {
   if (e === '0'){
      return 'No'
   } else {
      return 'Yes'
   }
}
export const DateFormat = (date) => {
   return moment(date).format("YYYY-MM-DD")
}
export const DateLong = (date) => {
   return moment(date).format("DD MMMM YYYY") === '01 January 0001' ? ' - ' : moment(date).format("DD MMMM YYYY")
}
export const CheckUndefined = (data) => {
   if (typeof(data) === 'undefined'){
      return false
   }
   return true
}

export const CheckResponse = (response) => {
   if(response.status === ApiResponseSuccess){
      return true
   }else if(response.status === ApiResponseStatusUnauthorized){
      window.location.href = "/login"
   }else{
      return false
   }
}
export const GetPriceAfterTax = (price, tax) => {
   return Math.ceil(parseFloat(price) / ((100 - tax) / 100) / 1000) * 1000 
}